import ApiService from "@/utils/request";

export const appServe = {
  queryPeopleLabel(params = {}) {
    return ApiService.query("/approval/config/project_label/", {
      params: params,
    });
  },
  queryAreaLabel(params = {}) {
    return ApiService.query("dashboard/mobile/mobile_overview/area_list/", {
      params: params,
    });
  },
};
